import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../hooks/useUser';

export const AdminCheck = () => {
    const { data: user, isFetching } = useUser();

    if (isFetching) return null;

    if (user?.role !== 'admin') return <Navigate to="/" />;

    return <Outlet />;
};
